export default __webpack_public_path__ + "static/media/no-permission.4664120d.webp";